export default "__VITE_ASSET__BQ16qfJH__"